import { colors } from '../../colors';
var address = {
  arrowColor: colors.neonPurple,
  textColor: colors.slateGrey,
  borderColor: colors.slateGrey,
  backgroundColor: colors.white
};
export default address;